import { Box, Card, CardContent, Typography, Rating } from '@mui/material';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
    return (
        <Box
            component={Link}
            to={`/product/${product.id}`}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                textDecoration: 'none',
                color: 'inherit',
            }}
        >
            {/* Image container */}
            <Box
                sx={{
                    width: '100%',
                    height: 300,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    component="img"
                    src={product.image?.[0]}
                    alt={product.name}
                    sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Box>

            {/* Content */}
            <CardContent sx={{ textAlign: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
                    <Rating value={product.rating || 4} size="small" readOnly />
                    <Typography variant="caption" sx={{ ml: 0.5 }}>
                        {product.reviews || 4} reviews
                    </Typography>
                </Box>
                <Typography fontSize="0.9rem" fontWeight={600}>
                    {product.name}
                </Typography>
                <Typography fontWeight={700} color="primary" mt={0.5}>
                    ${product.price}
                </Typography>
            </CardContent>
        </Box>
    );
};

export default ProductCard;
